<script>
  import { Upload } from 'element-ui'
  export default {
    name:'ElUpload',
    extends:Upload
  }
</script>
